export const NO_PROVIDER = 0
export const NOT_CONNECTED = 1
export const IN_PROGRESS = 2
export const CONNECTED = 3
